<template>
	<div>
		<div style="color: #3e3e3e;font-size: 18px;margin-bottom: 15px;">营销管理>券设置>效果数据</div>
		<el-row :gutter="15" class="cradData">
			<el-col :span="4">
				<div>
					<p>用券总成交额</p>
					<b>￥5,000</b>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<p>优惠总金额</p>
					<b>￥2,000</b>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<p>费效比</p>
					<b>30.0%</b>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<p>客单价</p>
					<b>￥5,000</b>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<p>领券总用户数</p>
					<b>800</b>
				</div>
			</el-col>
			<el-col :span="4">
				<div>
					<p>用券总用户数</p>
					<b>600</b>
				</div>
			</el-col>
		</el-row>
		<el-tabs type="border-card" style="margin-top: 30px;">
			<el-tab-pane label="定向发放记录">
				<p style="color: #999;font-size: 12px;">定向发放记录(222条)</p>
				<div class="tabelContent" style="margin-top: 20px;">
					<el-table :data="dataList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
						style="width: 100%">
						<el-table-column prop="name1" align="center" label="券名称"></el-table-column>
							<el-table-column label="定向用户" prop="name2" align="center"></el-table-column>
							<el-table-column prop="name3" align="center" label="已发放/已领取">
								<template slot-scope="scope">
									{{scope.row.name3 || 0}}/{{scope.row.name4 || 0}}
								</template>
							</el-table-column>
							<el-table-column prop="name5" align="center" label="发放时间"></el-table-column>
					</el-table>
					<el-pagination background style="margin-top: 30px;" layout="total, sizes, prev, pager, next, jumper"
						:page-size="10" :total="80">
					</el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane label="用券商品">
				<p style="color: #999;font-size: 12px;">付款商品件数(500)</p>
				<div class="tabelContent" style="margin-top: 20px;">
					<el-table :data="dataList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
						style="width: 100%">
						<el-table-column prop="name1" align="center" label="商品名称"></el-table-column>
						<el-table-column label="类型" prop="name2" align="center"></el-table-column>
						<el-table-column prop="name3" align="center" label="付款件数">
							<template slot-scope="scope">
								{{scope.row.name3 || 0}}/{{scope.row.name4 || 0}}
							</template>
						</el-table-column>
						<el-table-column prop="name5" align="center" label="付款人数"></el-table-column>
					</el-table>
					<el-pagination background style="margin-top: 30px;" layout="total, sizes, prev, pager, next, jumper"
						:page-size="10" :total="80">
					</el-pagination>
				</div>
			</el-tab-pane>
			<el-tab-pane label="领/用券用户">
				<div class="title">
					<div class="left">
					</div>
					<div class="right">
						<el-select v-model="fangshiState" style="width: 150px;margin-right: 20px;" size="small">
							<el-option v-for="item in fangshiStateList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-select v-model="moreState" style="width: 150px;margin-right: 20px;" size="small">
							<el-option v-for="item in moreStateList" :key="item.value" :label="item.label"
								:value="item.value">
							</el-option>
						</el-select>
						<el-button type="primary" size="small">导出表单</el-button>
					</div>
				</div>
				<div class="tabelContent" style="margin-top: 20px;">
					<el-table :data="dataList" :header-cell-style="{background:'#F2F2F4','text-align':'center'}"
						style="width: 100%">
						<el-table-column prop="name1" align="center" label="用户昵称"></el-table-column>
						<el-table-column label="手机号" prop="name2" align="center"></el-table-column>
						<el-table-column prop="name3" align="center" label="微信号">
							<template slot-scope="scope">
								{{scope.row.name3 || 0}}/{{scope.row.name4 || 0}}
							</template>
						</el-table-column>
						<el-table-column prop="name5" align="center" label="领劵方式"></el-table-column>
						<el-table-column prop="name5" align="center" label="领取时间"></el-table-column>
						<el-table-column prop="name5" align="center" label="是/否用券"></el-table-column>
						<el-table-column prop="name5" align="center" label="使用时间"></el-table-column>
					</el-table>
					<el-pagination background style="margin-top: 30px;" layout="total, sizes, prev, pager, next, jumper"
						:page-size="10" :total="80">
					</el-pagination>
				</div>
			</el-tab-pane>
		</el-tabs>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				dataList: [{
					name1: "剪发五元券",
					name2: "活跃用户",
					name3: 300,
					name4: 34,
					name5: "2020-08-17 20:00"
				}, {
					name1: "剪发五元券",
					name2: "活跃用户",
					name3: 300,
					name4: 34,
					name5: "2020-08-17 20:00"
				}],
				fangshiState: "全部领券方式",
				fangshiStateList: [{
					value: "全部领券方式",
					label: "全部领券方式"
				}, {
					value: "用户领取",
					label: "用户领取"
				}, {
					value: "定向发布",
					label: "定向发布"
				}, {
					value: "兑换码领取",
					label: "兑换码领取"
				}, {
					value: "完善归档",
					label: "完善归档"
				}],
				moreState: "全部（是否用卷）",
				moreStateList: [{
					value: "全部（是否用卷）",
					label: "全部（是否用卷）"
				}, {
					value: "是",
					label: "是"
				}, {
					value: "否",
					label: "否"
				}]
			}
		}
	}
</script>

<style lang="less">
	.cradData {
		width: 100%;

		.el-col {
			height: 150px;

			&>div {
				height: 150px;
				border-radius: 5px;
				background-color: #F2F2F4;
				box-sizing: border-box;
				padding: 5px 20px;

				b {
					font-size: 30px;
				}
			}
		}
	}

	.title {
		width: 100%;

		.left {
			float: left;
		}

		.right {
			float: right;
		}

		&::after {
			content: "";
			width: 1px;
			display: block;
			clear: both;
		}
	}
</style>